import useSWR from 'swr';
import { useEffect } from 'react';
import { axios } from '@service/axiosService';

export const useCurrentUserPermission = (projectId) => {
  const urlGet = `/api/v1/project/getBasicInfo/${projectId}`;

  useEffect(() => {}, [projectId]);

  const fetcher = () => axios.get(urlGet);

  const { data, error, mutate, isLoading } = useSWR(projectId, fetcher, {
    dedupingInterval: 30000,
  });

  return {
    projectBasicInfo: data,
    error,
    mutate,
    isLoading,
  };
};
